var $ = window.jQuery;

/**
 * Import node modules.
 */
// npm install smoothscroll-polyfill --save
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

/**
 * Require other JS libraries.
 */
// const $ = require('jquery');
const WebFont = require('webfontloader');
const lazysizes = require('./libs/lazysizes-5.3.1.js');
const jpInView = require('./libs/jpInView.js');

const Flickity = require('flickity');
const jQueryBridget = require("jquery-bridget");

const fitvids = require('fitvids');

Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);

/*
// https://github.com/typekit/webfontloader

WebFont.load({
	// GOOGLE FONTS
	// google: {
	// 	families: [
	// 		'Barlow Condensed:300,400,500,600,700'
	// 	]
	// },
	// TYPEKIT
	// typekit: { id: 'abc123' },
	// CALLBACK FOR WHEN FONTS LOAD (OPTIONAL)
	// active: dje_fonts_active_cb
});

// Callback function for when the fonts are loaded.
function dje_fonts_active_cb() {

}
*/


// Use lazysizes to get lazy loading on css background images.
document.addEventListener('lazybeforeunveil', function (e) {
	try {
		var bg = e.target.getAttribute('data-bg');
    if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
    }

	} catch (error) {
		console.log('Error with lazyload background:');
		console.log(error);
	}

});


$(document).ready(function() {
	initCarousel();
	formatClasses();

	fitvids('.basic-content');
})


function formatClasses() {
	$('.wysiwyg-content').each(function () {
        $(this).find('.link--arrow').parent().addClass('wysiwyg-parent--link-arrow');
        $(this).find('.larger-text').parent().addClass('wysiwyg-parent--larger-text');
        $(this).find('.smaller-text').parent().addClass('wysiwyg-parent--smaller-text');
        $(this).find('.button').parent().addClass('wysiwyg-parent--button');
    });
}

function initCarousel() {
	let $carousel = $('.carousel').flickity({
		adaptiveHeight: true,

		on: {
			ready: function() {
				let flickityContainer = $(this.$element[0]);
				let dots = flickityContainer.find(".dot");
				dots.each(function(index, ele) {
					if ( $(this).next().length ) {
						let line = $('<div>');
						line.addClass('dot-line');
						line.attr('data-line', 'dot line ' + (index + 2));
						line.insertBefore($(this).next());
					}
				})
			},
			change: function(index) {
				let flickityContainer = $(this.$element[0]);
				let dotLines = flickityContainer.find(".dot-line");
				dotLines.each(function(ind, ele) {
					if ( ind < index ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				})

				$('html, body').animate({
					scrollTop: flickityContainer.offset().top - 50,
				})
			}
		}
	});

	$(window).on('load', function() {
		$carousel.flickity('resize');
	})
}




/**
 * Layouts
 */

 const listing_announcements = require('./layouts/listing-announcements.js');
 const listing_announcements = require('./layouts/listing-news.js');

 /**
	* Components
  */

const listing_announcements = require('./components/navigation.js');
